@if (listOfCommands !== undefined) {
  <div>
    @if (!dialogRef) {
      <mat-card>
             @if (device?.email) {
        <mat-card-subtitle>Device Commands - {{ device?.profile?.firstName }}</mat-card-subtitle>
      } @else {
        <mat-card-subtitle>Device Commands</mat-card-subtitle>
      }

        <mat-card-content>
          <vp-device-command-list
            [commands]="listOfCommands"
            (sendCommand)="sendAdvancedCommand($event)"
          ></vp-device-command-list>
        </mat-card-content>
      </mat-card>

    } @else {
      @if (device?.email) {
        <h1 mat-dialog-title>Device Commands - {{ device?.profile?.firstName }}</h1>
      } @else {
        <h1 mat-dialog-title>Device Commands</h1>
      }

      <div mat-dialog-content>
        <vp-device-command-list
          [commands]="listOfCommands"
          (sendCommand)="sendAdvancedCommand($event)"
        ></vp-device-command-list>
      </div>
      <div mat-dialog-actions>
        <button type="button" mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>
          Close
        </button>
      </div>
    }
  </div>
} @else {
  <mat-spinner [diameter]="40"></mat-spinner>
}
